module.exports = __webpack_public_path__ + "static/media/news1.e5bc6c03.jpg";